import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { getColor, getTransition, vars } from '@flodesk/grain';
import { NavLink as ReactRouterNavLink } from 'react-router-dom';

type NavItem = {
  label: string;
  href: string;
};

const navItems: NavItem[] = [
  { label: 'Pages', href: '/v1/pages' },
  { label: 'Products', href: '/v1/products' },
];

const Header = styled.header`
  background-color: white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 96px;
  padding: 0 16px;
  width: 100%;
`;

const navStyles = css`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const Link = styled(ReactRouterNavLink)`
  font-weight: 500;
  color: ${getColor(vars.colors.shade6)};
  transition: color ${getTransition(vars.transitions.fast)};
  text-decoration: none;

  &:hover,
  &:active,
  &[aria-current='page'] {
    color: ${getColor(vars.colors.shade13)};
  }
`;

export default function Nav() {
  return (
    <Header>
      <nav css={navStyles}>
        {navItems.map(item => (
          <Link key={item.label} to={item.href}>
            {item.label}
          </Link>
        ))}
      </nav>
    </Header>
  );
}
